import { render, staticRenderFns } from "./LiabilitiesSelector.vue?vue&type=template&id=55f73c04&scoped=true&"
import script from "./LiabilitiesSelector.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesSelector.vue?vue&type=script&lang=js&"
import style0 from "./LiabilitiesSelector.vue?vue&type=style&index=0&id=55f73c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f73c04",
  null
  
)

export default component.exports